import {useParams} from 'react-router-dom'
import {useEffect, useState} from 'react'
import useRegisteredApps from './hooks/useRegisteredApps'
import useCurrentApp from './hooks/useCurrentApp'
import {useNotification} from '@enisco/mcc-react-lib'
import {useIntl} from 'react-intl'
import AppLauncher from './components/app-launcher/AppLauncher'
import {App} from './model/apps'

export const ExternalApp = () => {
  const intl = useIntl()
  const {module, app} = useParams()
  const [apps] = useRegisteredApps()
  const [, setCurrentApp] = useCurrentApp()
  const sendNotification = useNotification()
  const [loadedApp, setLoadedApp] = useState<App|null>(null)

  useEffect(() => {
    const appToLoad = apps.find((a) => a.module === module && a.app === app)
    if (!appToLoad) {
      sendNotification(
        'warning',
        intl.formatMessage({
          id: 'AppLauncher.AppNotFound',
          defaultMessage: 'App is not available'
        })
      )
      return
    }
    if (
      loadedApp &&
      appToLoad.module === loadedApp.module &&
      appToLoad.app === loadedApp.app
    ) {
      return
    }
    setCurrentApp(appToLoad)
    setLoadedApp(appToLoad)
  }, [module, app, apps])

  return <AppLauncher />
}
